export enum DatasetFieldFloatingOption {
    SUM = 'SUM',
    AVG = 'AVG'
}
